"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxFrag React.Fragment */
/** @jsx jsx */
const react_1 = require("react");
const b_1 = __importDefault(require("b_"));
const i18n_1 = __importDefault(require("@yandex-int/pythia-libs/lib/i18n"));
const common_components_1 = require("@yandex-int/pythia-libs/lib/common-components");
const markdown_renderer_1 = __importDefault(require("@yandex-int/pythia-libs/lib/markdown-renderer"));
const modal_1 = require("src/context/modal");
const attachment_1 = __importDefault(require("../attachment"));
const styles = __importStar(require("./question.styles"));
// @ts-expect-error TS(2345): Argument of type 'readonly ["blockquote", "fence",... Remove this comment to see the full error message
const mdRender = (0, markdown_renderer_1.default)(common_components_1.MARKDOWN_OPTIONS);
const b = b_1.default.with('question');
const imgRe = /^!\[.*\]\(.*\)/;
/* export interface QuestionProps {
    mix?: string;
    label: string;
    errors?: string[];
    children: any;
    attachment?: AttachmentFieldType;
    attachmentRef?: any; // oneOf func | { current: elementType };
    required?: boolean;
    isPressed?: boolean;
    theme: Theme;
    imageAlign?: boolean;
    caption?: string;
    id: number;
    type: QuestionType;
} */
// eslint-disable-next-line complexity, max-statements
function Question(props) {
    const { imageAlign = false, errors = [], caption = '', children, required = false, attachment, theme = 'common', id = 0, type, attachmentRef, isPressed, showScreeningLabel = false, visible, choiceType } = props;
    const i18n = (0, i18n_1.default)(['labels']);
    let { label = '' } = props;
    const hasImgInDescription = imgRe.test(label);
    // показываем картинку сбоку если включен флаг imageAlign, всегда в видеотеме
    const isShowSideImage = !attachment && hasImgInDescription && (imageAlign || theme === 'video');
    const context = (0, modal_1.useModalContext)();
    const dualChoice = choiceType === 'dualChoice';
    let imgLabel = '';
    if (isShowSideImage) {
        const match = imgRe.exec(label);
        if (match) {
            [imgLabel] = match;
        }
        label = label.replace(imgRe, '');
    }
    const showRequired = required && !['transparent'].includes(theme) && type !== 'ux';
    const labelClasses = b('label', {
        required: showRequired ? 'yes' : undefined,
        'with-caption': caption ? 'yes' : undefined,
        preset: context === null || context === void 0 ? void 0 : context.surveyPreset
    });
    const image = mdRender(imgLabel);
    const questionLabel = mdRender(label);
    const sideAlign = (theme === 'video' && attachment) || isShowSideImage;
    const classes = b({
        theme,
        sideimage: sideAlign ? 'yes' : 'no',
        type,
        pressed: isPressed,
        hidden: !visible
    });
    const questionDescription = (
    // eslint-disable-next-line react/jsx-fragments
    (0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [label && ((0, jsx_runtime_1.jsx)("div", { 
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: { __html: questionLabel }, className: labelClasses })), caption && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('caption') }, { children: caption }))] }));
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: styles.question(), className: classes, id: `q${id}` }, { children: [showScreeningLabel && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('bubble') }, { children: i18n(['screening']) })), visible === false && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('bubble') }, { children: i18n(['questionHidden']) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('content', { error: errors.length ? 'yes' : 'no' }) }, { children: [theme === 'video' && sideAlign && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('duplicate-description') }, { children: questionDescription }))), isShowSideImage && ((0, jsx_runtime_1.jsx)("div", { 
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML: { __html: image }, className: b('side-image') })), theme === 'video' && attachment && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('side-image') }, { children: (0, jsx_runtime_1.jsx)(attachment_1.default, { ref: attachmentRef, value: attachment }) }))), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('content-wrapper', {
                            'side-align': sideAlign ? 'yes' : 'no'
                        }) }, { children: dualChoice ?
                            (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [theme !== 'video' && attachment && attachment.position === 'top' && ((0, jsx_runtime_1.jsx)(attachment_1.default, { ref: attachmentRef, value: attachment })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: labelClasses }, { children: children })), theme !== 'video' && attachment && attachment.position === 'bottom' && ((0, jsx_runtime_1.jsx)(attachment_1.default, { ref: attachmentRef, value: attachment })), errors[0] && theme !== 'video' && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('error') }, { children: errors[0] })))] }) : (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [theme !== 'video' && attachment && attachment.position === 'top' && ((0, jsx_runtime_1.jsx)(attachment_1.default, { ref: attachmentRef, value: attachment })), questionDescription, theme !== 'video' && attachment && attachment.position === 'bottom' && ((0, jsx_runtime_1.jsx)(attachment_1.default, { ref: attachmentRef, value: attachment })), children, errors[0] && theme !== 'video' && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('error') }, { children: errors[0] })))] }) }))] }))] })));
}
exports.default = Question;
